import { LogoImage, LogoImageRight } from 'customizations'
import { User, MenuApi } from 'api'
import { withRouter } from "react-router"
import { SmartButtonStub, SmartButtonLink } from 'ui/smart-buttons'
import LoginModal from 'ui/public/LoginModal'
import Modal from 'shared/modal'
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Alerts from './alerts';
import { SmartButtonFeedList } from 'ui/smart-buttons'
import { some } from 'lodash'

const Navbar = (props) => {
  // State
  const [loginModalOpen, setLoginModalOpen] = useState(false)
  const [prefetchedSignupSettings, setPrefetchedSignupSettings] = useState(null)
  const [menuItems, setMenuItems] = useState([])
  const defaultMenuItems = menuItems && menuItems.filter(menu => menu.valid && ( menu.item_type === null || menu.item_type === undefined) && menu.id != 'my_feed' &&
  menu.name?.includes('Neighbors')) ;

  // Consts
  const isGuestExperience = User.current?.isGuestExperience
  const isTouchScreen = !application.path.includes('/touch-screen')

  // Hooks
  useEffect(() => {
    loadMenus()
    if(queryParams('openSignIn') == 'true')
      showLoginModal()
    application.state.on("user:update", () => forceUpdate())
  }, [])

  useEffect(() => {
    if (!isGuestExperience) return
    Backend.get('/signup_settings')
      .then((data) => {
        setPrefetchedSignupSettings(data)
        const url = data?.sign_in_page_banner
        if (url) { const img = new Image(); img.src = url }
      })
      .catch(() => setPrefetchedSignupSettings({}))
  }, [isGuestExperience])

  // Custom Methods
  const hideLoginModal = () => setLoginModalOpen(false)
  const loadMenus = async () => setMenuItems(await MenuApi.get('load'))
  const lockBodyScroll = () => $("html, body").css("overflow", "hidden")

  const loggedInUserOnlyMenuItems = () => {
    if(!isGuestExperience) {
      return <div className="mb-4 col-12 col-sm-6 col-lg-3">
        <h6 className="font-weight-bold text-uppercase text-black menu-header-items">My Account</h6>
        { App.user?.regular && !props.location.search.includes('mobile=true') &&
          <>
            {defaultMenuItems &&
              defaultMenuItems.length > 0 &&
              defaultMenuItems.map((menu, index) => (
              <>
                <Dropdown.Item
                  eventKey={menu.id}
                  href={'/app#/' + menu.route}
                  onClick={closeDropdownMenu}
                  className={classNames("nav-item nav-link px-0 text-muted custom-text-community", {
                    unsupported: menu.unsupported,
                  })}
                >
                  {menu.name}
                </Dropdown.Item>
                {index < defaultMenuItems.length - 1 && <Dropdown.Divider />}
              </>
            ))}
            <Dropdown.Divider />
            <Dropdown.Item
              eventKey={'settings'}
              href='/app#/settings'
              onClick={closeDropdownMenu}
              className={classNames("nav-item nav-link px-0 text-muted custom-text-community")}
            >
              My Account Settings
            </Dropdown.Item>
            <Dropdown.Divider />
          </>
        }
        { User.current?.regular &&
          <Dropdown.Item
            eventKey={'logout'}
            onClick={signOut}
            href="#"
            className={classNames("nav-item nav-link px-0 font-weight-bold text-black menu-header-items")}
          >
            Log Out
          </Dropdown.Item>
        }
      </div>
    }
  }

  const loginButton = () => {
    if (App.loginOption.includes('user'))
      return <SmartButtonStub text="My Account" buttonType="button" className="primary custom-font-size custom-font-family mb-1 mb-md-0" click={showLoginModal}/>
  }

  const queryParams = (key) => {
    let search = props.location.search
    let query = new URLSearchParams(search)
    return query.get(key)
  }

  const renderLogo = () => {
    const { current: { logoUrl } } = User
    const isEmbedPage = application.path.includes('/embed-calendar')
    const isTouchScreenPage = application.path.includes('/touch-screen')

    const imageSrc = (!logoUrl || logoUrl === "null") ? LogoImage : logoUrl
    const imageElement = <img className="main-logo" src={imageSrc} alt="Homepage" />

    // Make logo clickable only if not embed or touch screen
    const shouldBeClickable = !isEmbedPage && !isTouchScreenPage

    return shouldBeClickable ? <a href="/">{imageElement}</a> : imageElement
  }


  const closeDropdownMenu = () => {
    $('.dropdown-menu-custom').removeClass('show');
    $('.dropdown-toggle').dropdown('hide');
    $("html, body").css("overflow", "auto");
  };

  const renderMenuDropdown = () => {
    if (application.path.includes('/change-password'))
      return null
    const eventMenuItems = menuItems && menuItems.filter(menu => menu.item_type === 'Event' && menu.valid );
    const placeMenuItems = menuItems && menuItems.filter(menu => menu.item_type === 'Place' && menu.valid );

    return <Dropdown onToggle={toggleDropdown}>
      <Dropdown.Toggle
        id="dropdown-custom"
        className="d-inline-flex align-items-center font-weight-medium text-decoration-none"
      >
        Community Menu
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-custom p-4 shadow-lg custom-padding">
        <div className="row">
          <div className={`mb-4 col-12 col-sm-6 ${ isGuestExperience ? 'col-lg-4' : 'col-lg-3'}`}>
            <h6 className="font-weight-bold text-uppercase text-black menu-header-items">Community Home</h6>
            <SmartButtonFeedList base="/community-calendar" onClickSmartButton={closeDropdownMenu} />
          </div>

          <div className={`mb-4 col-12 col-sm-6 ${ isGuestExperience ? 'col-lg-4' : 'col-lg-3'}`}>
            <h6 className="font-weight-bold text-uppercase text-black menu-header-items">Community Activities</h6>
            { renderMenuItems(eventMenuItems) }
          </div>

          <div className={`mb-4 col-12 col-sm-6 ${ isGuestExperience ? 'col-lg-4' : 'col-lg-3'}`}>
            <h6 className="font-weight-bold text-uppercase text-black menu-header-items">Community Amenities</h6>
            { renderMenuItems(placeMenuItems) }
          </div>

          { loggedInUserOnlyMenuItems() }
        </div>
      </Dropdown.Menu>
    </Dropdown>
  }

  const renderMenuItems = (menuItems) => {
    return menuItems?.map((menu, index) => (
      <React.Fragment key={menu.id}>
        <Dropdown.Item
          eventKey={menu.id}
          href={`/app#/${menu.route}`}
          onClick={closeDropdownMenu}
          className={classNames("nav-item nav-link px-0 text-muted custom-text-community break-spaces",
            { unsupported: menu.unsupported}
          )}
        >
          { menu.name }
        </Dropdown.Item>
        { index < menuItems.length - 1 && <Dropdown.Divider /> }
      </React.Fragment>
    ))
  }

  const renderNavbar = () => {
    return <div className='MainNav'>
      <div className="px-3 py-3 d-flex flex-column flex-lg-row justify-content-between align-items-center">
        <div className="d-flex justify-content-start align-items-center nav-brand">
          { renderLogo()}
          {!application.path.includes('/embed-calendar') && isTouchScreen && <div className="d-none d-lg-block border-left border-black mx-3" style={{ height: '40px' }}></div> }
          <div className="d-lg-block ml-auto m-lg-0">
            {!application.path.includes('/embed-calendar') && isTouchScreen && renderMenuDropdown()}
          </div>
        </div>
        <div className="d-md-flex align-items-center justify-content-end text-secondary">
          <div className="d-lg-flex flex-column flex-lg-row align-items-center">
            { renderNavbarForm() }
          </div>
        </div>
      </div>
      {
        isGuestExperience &&
        <Modal title='Login' opened={loginModalOpen} onClose={hideLoginModal}>
          <LoginModal prefetchedSignupSettings={prefetchedSignupSettings} />
        </Modal>
      }
    </div>
  }

  const renderNavbarForm = () => {
    return <div className="form-inline justify-content-center">
      { isGuestExperience && !application.path.includes('/community-calendar') && !application.path.includes('/large-screen') && !application.path.includes('/embed-calendar')  && !application.path.includes('/touch-screen') && loginButton() }
      { !application.path.includes('/large-screen') && !application.path.includes('/touch-screen') && !application.path.includes('/embed-calendar') &&
        <>
          <SmartButtonLink text="Community Calendar" className="primary custom-font-size custom-font-family mb-1 mb-md-0" to="/community-calendar" />
          <Alerts />
          <span className="navbar-text sidebar d-flex align-items-center">
            <img
              width="36"
              height="36"
              src={!isGuestExperience ? (User.current?.picture || LogoImageRight) : LogoImageRight}
              className={'profile-image'}
              alt={User.current?.name ? `${User.current.name}'s profile` : "Profile image"}
            />
          </span>
        </>
      }
    </div>
  }

  const shouldSkipNavbar = () => {
    let pages = ['/signup', '/login', '/app-downloads', '/marketplace-signup', '/sms-opt', 'large-screen', '/touch-screen', '/kiosk']
    return some(pages.map(page => application.path.includes(page)))
  }

  const showLoginModal = () => setLoginModalOpen(true)

  const signOut = () => App.signOut()

  const toggleDropdown = (isOpen) => {
    if (isOpen) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  };

  const unlockBodyScroll = () => $("html, body").css("overflow", "")

  // render
  if(!shouldSkipNavbar())
    return <div> { renderNavbar() } </div>
  else
    return <div> </div>
}

export default withRouter(Navbar)
